import React, { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Dashboard } from 'models/dashboard';
import './DashboardList.scss';
import { Button } from '@flightaware/ui-components';

interface DashboardListProps {
    dashboards: Dashboard[];
    allowCreate: boolean;
}

const DashboardList: FC<DashboardListProps> = (props) => {
    const navigate = useNavigate();

    let listContent;
    if (!props.dashboards || props.dashboards.length === 0) {
        listContent = <div>No dashboards found</div>;
    } else {
        const listItems = props.dashboards.map((dashboard) => {
            const operatorsText =
                dashboard.filters.operators.length > 0 ? dashboard.filters.operators.join(', ') : 'any';
            const airportsText = dashboard.filters.airports.length > 0 ? dashboard.filters.airports.join(', ') : 'any';
            const registrationsText =
                dashboard.filters.registrations.length > 0 ? dashboard.filters.registrations.join(', ') : 'any';

            return (
                <li key={dashboard.id} className="dashboard-list__item">
                    <Link to={`/dashboards/${dashboard.id}`}>
                        <div>{dashboard.name}</div>
                        <span>Operators: {operatorsText}</span>
                        <span>Airports: {airportsText}</span>
                        <span>Registrations: {registrationsText}</span>
                    </Link>
                </li>
            );
        });
        listContent = <ul className="dashboard-list__list">{listItems}</ul>;
    }

    return (
        <div className="dashboard-list fixed-width" data-testid="dashboard-list">
            <h1>Dashboards</h1>
            {listContent}

            {props.allowCreate && (
                <Button
                    handleClick={() => {
                        navigate('/admin/dashboards/new');
                    }}
                    size="medium"
                    variant="primary"
                >
                    Create new dashboard
                </Button>
            )}
        </div>
    );
};

export default DashboardList;
